export function formatDateOnly(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function parseDateOnly(value: string | null | undefined): Date | undefined {
  if (!value) return undefined;
  const parts = value.split('-').map((part) => Number(part));
  if (parts.length !== 3 || parts.some(Number.isNaN)) {
    return undefined;
  }
  return new Date(parts[0], parts[1] - 1, parts[2]);
}

export function getTodayDateString(): string {
  return formatDateOnly(new Date());
}
